
import parallel from 'async/parallel'
import 'components/ckeditor.tag'
import 'components/datatable.tag'
import 'pages/products/modifications/modification-edit.tag'
import 'pages/products/modifications/modification-edit-modal.tag'

riot.tag2('product-edit-modifications', '  <div class="row">\n    <div class="col-md-12">\n      <div class="form-inline m-b-3">\n        <div class="form-group">\n          <button class="btn btn-primary" type="button" onclick="{addGroup}"><i class="fa fa-plus"></i> Добавить группу</button>\n          <yield to="toolbar">\n            <yield from="toolbar"></yield>\n          </yield>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-12">\n      <ul class="nav nav-tabs m-b-2" if="{value.length &gt; 0}">\n        <li class="{active: activeTab === i}" each="{item, i in value}"><a onclick="{changeTab}"><span>{item.name}</span>\n            <button class="close" onclick="{closeTab}" type="button"><span>&times;</span></button></a></li>\n      </ul>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-12">\n      <product-edit-modifications-group if="{value.length &gt; 0}" value="{value[activeTab]}" images="{images}"></product-edit-modifications-group>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this;
self.images = [];
Object.defineProperty(self.root, 'value', {
    get: function get() {
        return self.value;
    },
    set: function set(value) {
        self.value = value;
        self.update();
    }
});

self.activeTab = 0;

self.changeTab = function (e) {
    self.activeTab = e.item.i;
};

self.closeTab = function (e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    self.value = self.value.slice(0, self.value.length);
    self.value.splice(e.item.i, 1);

    if (e.item.i <= self.activeTab) if (self.activeTab > 0) self.activeTab -= 1;

    var event = document.createEvent('Event');
    event.initEvent('change', true, true);
    self.root.dispatchEvent(event);
};

self.addGroup = function () {
    modals.create('product-edit-modifications-group-select-modal', {
        type: 'modal-primary',
        size: 'modal-lg',
        beforeSuccess: function beforeSuccess(response, xhr) {
            if (self.value && self.value instanceof Array && self.value.length > 0) {
                (function () {
                    var ids = self.value.map(function (item) {
                        return item.id;
                    });
                    var items = response.items.filter(function (item) {
                        return ids.indexOf(item.id) === -1;
                    });

                    response.items = items;
                })();
            }
        },
        submit: function submit() {
            var items = this.tags.catalog.tags.datatable.getSelectedRows();

            if (items.length > 0 && !(self.value instanceof Array)) self.value = [];

            items = items.map(function (item) {
                item.items = [];
                return item;
            });

            self.value = self.value.concat(items);

            var event = document.createEvent('Event');
            event.initEvent('change', true, true);
            self.root.dispatchEvent(event);
            this.modalHide();
        }
    });
};

self.on('update', function () {
    if (opts.value) self.value = opts.value;
    if (opts.images) self.images = opts.images;

    if (opts.name) self.root.name = opts.name;
});
});
riot.tag2('product-edit-modifications-group', '  <div class="form-inline m-b-3">\n    <div class="form-group">\n      <button class="btn btn-primary" type="button" onclick="{addModification}"><i class="fa fa-plus"></i> Добавить модификацию</button>\n    </div>\n    <div class="form-group">\n      <button class="btn btn-danger" if="{selectedCount}" onclick="{remove}" title="Удалить" type="button"><i class="fa fa-trash">{(selectedCount > 1) ? ⁗&nbsp;⁗ : ⁗⁗}</i><span class="badge" if="{selectedCount &gt; 1}">{selectedCount}</span></button>\n    </div>\n  </div>\n  <div class="table-responsive">\n    <datatable cols="{cols}" rows="{items}" handlers="{handlers}">\n      <datatable-cell each="{item, i in parent.parent.newCols}" name="{item.name}">{row.values[i].value}</datatable-cell>\n      <datatable-cell name="article" style="width-max: 150px;">\n        <input name="article" value="{row.article}" onchange="{handlers.change}">\n      </datatable-cell>\n      <datatable-cell name="stock" style="width-max: 80px;">\n        <input name="stock" min="-1" value="{row.stock}" readonly type="{\'number\'}">\n      </datatable-cell>\n      <datatable-cell name="priceRetail" style="width-max: 100px;">\n        <input name="priceRetail" min="0" step="0.01" value="{row.priceRetail}" onchange="{handlers.change}" type="{\'number\'}">\n      </datatable-cell>\n\n\n      <datatable-cell name="description">\n        <input name="description" value="{row.description}" onchange="{handlers.change}">\n      </datatable-cell>\n      <datatable-cell name="id" onclick="{handlers.edit}"><i class="fa fa-edit"></i> Настроить</datatable-cell>\n      <datatable-cell name="default" style="width-max: 40px;"><i class="fa fa-fw {row.default ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}" onclick="{handlers.isDefaultClick}"></i></datatable-cell>\n    </datatable>\n  </div>\n  <bs-pagination if="{value.items.length &gt; pages.limit}" name="paginator" onselect="{pages.change}" pages="{pages.count}" page="{pages.current}"></bs-pagination>\n', '', '', function(opts) {
'use strict';

var self = this;

self.cols = [];
self.items = [];
self.images = [];

self.pages = {
    count: 0,
    current: 1,
    limit: 15,
    change: function change(e) {
        self.pages.current = e.currentTarget.page;
    }
};

self.getPageItems = function () {
    var count = self.value.items.length;

    self.pages.count = Math.ceil(count / self.pages.limit);

    if (self.pages.current > self.pages.count) {
        self.pages.current = self.pages.count;
    }

    self.pages.current = self.pages.current == 0 ? 1 : self.pages.current;

    var offset = (self.pages.current - 1) * self.pages.limit;
    var end = offset + self.pages.limit;

    var items = self.value.items.filter(function (item, i) {
        return i > offset - 1 && i < end;
    });

    return items;
};

self.initCols = [{ name: 'article', value: 'Артикул' }, { name: 'stock', value: 'Остаток' }, { name: 'priceRetail', value: 'Розница' },
//{name: 'priceSmallOpt', value: 'Малый опт'},
//{name: 'priceOpt', value: 'Опт'},
{ name: 'description', value: 'Описание' }, { name: 'id', value: '' }, { name: 'default', value: '', classes: 'fa fa-2x fa-check', title: 'Выбор модификации по умолчанию' }];

self.addModification = function () {
    modals.create('product-edit-modifications-add-modal', {
        type: 'modal-primary',
        columns: self.value.columns,
        submit: function submit() {
            var getIndexs = function getIndexs() {
                var counts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

                var count = counts.reduce(function (p, c) {
                    return p * c;
                });
                index = index > count ? count : index;
                var result = [];

                counts.reduceRight(function (p, c, i) {
                    result[i] = p % c;
                    return Math.floor(p / c);
                }, index);

                return result;
            };

            var getValues = function getValues(items, indexs) {
                return items.map(function (item, i) {
                    return item[indexs[i]];
                });
            };

            var items = [];

            if (this.tags.datatable instanceof Array) {
                this.tags.datatable.forEach(function (item) {
                    items.push(item.getSelectedRows());
                });
            } else {
                items.push(this.tags.datatable.getSelectedRows());
            }

            var counts = items.map(function (item) {
                return item.length;
            });
            var count = counts.reduce(function (p, c) {
                return p * c;
            });
            count = count > 1000 ? 1000 : count;

            for (var i = 0; i < counts.length; i++) {
                if (counts[i] == 0) {
                    popups.create({
                        style: 'popup-danger',
                        title: 'Ошибка',
                        text: 'Должны быть выбраны один или несколько пунктов в каждой категории',
                        timeout: 0
                    });
                    return;
                }
            }

            for (var _i = 0; _i < count; _i++) {
                var indexs = getIndexs(counts, _i);
                var values = getValues(items, indexs);
                self.value.items.push({
                    article: self.parent.parent.item.article,
                    count: -1,
                    priceRetail: 0,
                    priceSmallOpt: 0,
                    priceOpt: 0,
                    description: '',
                    values: values
                });
            }

            this.modalHide();
            self.update();
        }
    });
};

self.remove = function () {
    self.selectedCount = 0;

    var items = self.tags.datatable.getSelectedRows();

    self.value.items = self.value.items.filter(function (item) {
        return items.indexOf(item) === -1;
    });
};

self.handlers = {
    change: function change(e) {
        if (!e.target.name) return;

        var bannedTypes = ['checkbox', 'file', 'color', 'range', 'number'];

        if (e.target && bannedTypes.indexOf(e.target.type) === -1) {
            var selectionStart = e.target.selectionStart;
            var selectionEnd = e.target.selectionEnd;
        }

        if (e.target && e.target.type === 'checkbox' && e.target.name) e.item.row[e.target.name] = e.target.checked;
        if (e.target && e.target.type !== 'checkbox' && e.target.name) e.item.row[e.target.name] = e.target.value;
        if (e.currentTarget.tagName !== 'FORM' && e.currentTarget.name !== '') e.item.row[e.currentTarget.name] = e.currentTarget.value;

        if (e.target && bannedTypes.indexOf(e.target.type) === -1) {
            this.update();
            e.target.selectionStart = selectionStart;
            e.target.selectionEnd = selectionEnd;
        }
    },
    edit: function edit(e) {
        modals.create('product-edit-modifications-edit-modal', {
            type: 'modal-primary',
            item: e.item.row,
            images: opts.images,
            submit: function submit() {
                e.item.row = this.item;
                this.modalHide();
                self.update();
            }
        });
    },
    isDefaultClick: function isDefaultClick(e) {
        var selIndex = e.item.row.default;
        self.items.forEach(function (item, index) {
            item.default = false;
        });
        e.item.row.default = !selIndex;
        self.update();
    }
};

self.on('update', function () {
    if (opts.value) {
        if (self.value !== opts.value) self.selectedCount = 0;

        self.value = opts.value;
        self.items = self.getPageItems() || [];

        if (self.value.columns && self.value.columns instanceof Array) {

            self.newCols = self.value.columns.map(function (item, i) {
                return { name: i, value: item.name };
            });
            self.newCols.sort(function (varA, varB) {
                return varA.id - varB.id;
            });

            self.cols = self.newCols.concat(self.initCols);
        }
    }
    if (opts.images) self.images = opts.images;
});

self.one('updated', function () {
    self.tags.datatable.on('row-selected', function (count) {
        self.selectedCount = count;
        self.update();
    });
});
});
riot.tag2('product-edit-modifications-group-select-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Модификации</div>\n    </yield>\n    <yield to="body">\n      <catalog object="Modification" cols="{parent.cols}" add="{parent.add}" remove="{parent.remove}" dblclick="{parent.opts.submit.bind(this)}" store="product-edit-modifications-group-select-modal" reload="true" handlers="{parent.handlers}" before-success="{parent.opts.beforeSuccess}">\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="type" style="width: 150px;">{handlers.types[row.vtype]}</datatable-cell>\n        </yield>\n      </catalog>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('remove');
self.collection = 'Modification';

self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'type', value: 'Тип ценообразования' }];

self.add = function (e) {
    modals.create('modification-edit-modal', {
        type: 'modal-primary',
        title: 'Добавить модификацию',
        submit: function submit(e) {
            var params = this.item;
            var _this = this;
            if (!this.error) {
                API.request({
                    object: 'Modification',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        self.tags['bs-modal'].update();
                        self.tags['bs-modal'].tags.catalog.reload();
                        _this.modalHide();
                    }
                });
            }
        }
    });
};

self.handlers = {
    types: {
        0: 'Добавляет к цене',
        1: 'Умножает на цену',
        2: 'Замещает цену'
    }
};
});
riot.tag2('product-edit-modifications-add-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить модификации</div>\n    </yield>\n    <yield to="body">\n      <div each="{table, i in parent.items}">\n        <h4>{table.name}</h4>\n        <datatable cols="{table.cols}" rows="{table.items}">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="value">{row.value}</datatable-cell>\n        </datatable>\n      </div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">OK</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.columns = opts.columns;
self.items = [];
self.initCols = [{ name: 'id', value: '#', width: '60px' }];

var request = function request(index, id) {
    return function (callback) {
        API.request({
            object: 'FeatureValue',
            method: 'Fetch',
            data: { filters: { field: 'idFeature', value: id } },
            success: function success(response) {
                var _self$columns$index = self.columns[index],
                    name = _self$columns$index.id,
                    value = _self$columns$index.name;

                self.columns[index].items = response.items;
                self.columns[index].cols = self.initCols.concat([{ name: name, value: value }]);
                self.items[index] = self.columns[index];

                callback(null, 'success');
            },
            error: function error(response) {
                callback('error', null);
            }
        });
    };
};

self.on('mount', function () {
    var requests = self.columns.map(function (item, i) {
        return new request(i, item.id);
    });

    parallel(requests, function (err, res) {
        self.update();
    });
});
});
riot.tag2('product-edit-modifications-images-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Выбрать из библиотеки</div>\n    </yield>\n    <yield to="body">\n      <div class="row">\n        <div class="col-md-12">\n          <catalog-static name="gallery" cols="{cols}" rows="{value}" catalog="{catalog}" upload="{upload}">\n\n            <yield to="body">\n              <datatable-cell name="" style="width: 100px;"><img riot-src="{row.imageUrlPreview}" style="max-width: 64px;"></datatable-cell>\n              <datatable-cell name="">\n                <p class="form-control-static">{row.imageFile}</p>\n              </datatable-cell>\n            </yield>\n          </catalog-static>\n        </div>\n      </div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;
self.on('mount', function () {
    var modal = self.tags['bs-modal'];
    modal.cols = [{ name: '', value: 'Картинка' }, { name: '', value: 'Наименование' }];
    if ('value' in opts) {
        modal.value = opts.value || [];
        console.log(modal.value);
        modal.update();
    }
});
});
riot.tag2('product-edit-modifications-list-images', '  <catalog-static name="{opts.name}" cols="{cols}" rows="{value}" catalog="{catalog}" upload="{upload}" remove="true" reorder="true">\n    <yield to="toolbar">\n\n      <div class="form-group" if="{checkPermission(&quot;images&quot;, &quot;1000&quot;)}">\n        <button class="btn btn-success" onclick="{opts.catalog}" type="button"><i class="fa fa-picture-o"></i> выбрать</button>\n      </div>\n    </yield>\n    <yield to="body">\n      <datatable-cell name="" style="width: 100px;"><img riot-src="{row.imageUrlPreview}" style="max-widt: 40px;"></datatable-cell>\n      <datatable-cell name="">\n        <p class="form-control-static">{row.imageFile}</p>\n      </datatable-cell>\n    </yield>\n  </catalog-static>\n', '', '', function(opts) {
'use strict';

var self = this;
self.mixin('permissions');
self.value = [];
self.newIndex = -1;
self.oldIndex = -1;

Object.defineProperty(self.root, 'value', {
    get: function get() {
        return self.value;
    },
    set: function set(value) {
        self.value = value || [];
        self.update();
    }
});

self.cols = [{ name: '', value: 'Картинка' }, { name: '', value: 'Наименование' }];

self.catalog = function (e) {
    //console.log(self.images)
    modals.create('product-edit-modifications-images-modal', {
        type: 'modal-primary',
        value: self.images,
        submit: function submit() {
            self.value = self.value || [];
            var sort = 0;
            self.value.forEach(function (item) {
                if (item.sortIndex > sort) sort = item.sortIndex;
            });
            this.tags.gallery.items.forEach(function (item) {
                if (item.__selected__) {
                    var find = false;
                    self.value.forEach(function (item1) {
                        if (item1.id == item.id) find = true;
                    });
                    if (!find) {
                        self.value.push({
                            id: item.id,
                            imageFile: item.imageFile,
                            imageUrlPreview: item.imageUrlPreview,
                            imageUrl: item.imageUrl,
                            sortIndex: sort + 1
                        });
                    }
                }
            });
            var event = document.createEvent('Event');
            event.initEvent('change', true, true);
            self.root.dispatchEvent(event);

            //console.log(self.value)

            self.update();
            this.modalHide();
        }
    });
};
self.on('update', function () {
    if ('name' in opts && opts.name !== '') self.root.name = opts.name;

    if ('images' in opts) self.images = opts.images || [];

    if ('value' in opts && !self.value) self.value = opts.value || [];
});
self.on('updated', function () {
    self.tags['catalog-static'].tags.datatable.on('reorder-end', function (newIndex, oldIndex) {
        if (newIndex === self.newIndex && oldIndex === self.oldIndex) {
            return false;
        }

        //console.log(newIndex, oldIndex, self.newIndex, self.oldIndex)
        self.newIndex = newIndex;
        self.oldIndex = oldIndex;

        self.tags['catalog-static'].value.splice(newIndex, 0, self.tags['catalog-static'].value.splice(oldIndex, 1)[0]);
        var temp = self.tags['catalog-static'].value;
        self.rows = [];
        self.update();

        self.tags['catalog-static'].value = temp;

        self.tags['catalog-static'].items.forEach(function (item, sort) {
            item.sortIndex = sort;
        });
    });
});
});
riot.tag2('product-edit-modifications-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Настроить модификацию</div>\n    </yield>\n    <yield to="body">\n      <form action="" onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-12">\n            <product-edit-modifications-list-images name="images" value="{item.images}" images="{images}"></product-edit-modifications-list-images>\n          </div>\n        </div>\n        <hr>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group">\n              <label class="control-label">Описание</label>\n              <ckeditor name="description" value="{item.description}"></ckeditor>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Применить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;
self.on('mount', function () {
    var modal = self.tags['bs-modal'];
    modal.mixin('change');
    modal.item = opts.item || {};
    modal.images = opts.images || {};
    self.update();
});
});


// WEBPACK FOOTER //
// ./pages/products/products/product-edit-modifications.tag